import { ErrorAPI } from 'api/Assessor/methods';
import duvidasAPI from 'api/DuvidasFrequentes';
import documentosAPI from 'api/EventoAssociado/documentos';
import eventoAPI from 'api/EventoAssociado/evento';
import pautasApi, { ResultadoParcialResponse } from 'api/EventoAssociado/pauta';
import { ErrorApi } from 'api/interfaces';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IReducer } from 'store/Reducer';
import { getPautaAssociadoWithOrderedOptions } from 'helpers/utils/AssembleiaUtils';
import trigger from 'helpers/utils/DownloadTrigger';
import {
  getAssembleiasAssociadoEndpoint,
  getAssembleiasVotoEndpoint,
  getEventoAssociadoEndpoint,
} from 'library/Apis';
import ApiService from 'services/ApiService';
import { toRequest } from 'helpers/utils/RequestUtils';
import {
  AssembleiasAssociadoActionTypes,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA,
  // ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
  ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION,
  IAssembleiaAssociadoDeleteCurrentEvent,
  IAssembleiaAssociadoRefresh,
  ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO,
  ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE,
} from './AssembleiasAssociadoActionTypes';
import {
  IAssembleiaAssociadoEvento,
  IAssembleiaAssociadoPauta,
  IAssembleiaAssociadoPautaVoto,
  IAssembleiaAssociadoRespostaPauta,
  IAssembleiaConsultaByCpfCnpj,
  IAssembleiaContaAssociado,
  IAssembleiaContasAssociado,
  IEventosPorAssociado,
} from './AssembleiasAssociadoReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';

type ThunkActionDefault = ThunkAction<Promise<void>, IReducer, undefined, any>;

export const assembleiaAssociadoActionsRefresh = (
  assembleia: IWSAssembleia
): IAssembleiaAssociadoRefresh => {
  return {
    type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH,
    payload: assembleia,
  };
};

export const assembleiaAssociadoActionsClearedEvent = () => {
  return {
    type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT,
  };
};

export const assembleiasAssociadoActionsRegistraVoto = (
  idItemPauta: number,
  idPauta: number,
  callbackSuccess?: (voto: IAssembleiaAssociadoPautaVoto[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    const data = {
      idItemPauta,
      idPauta,
    };
    toRequest(
      ApiService.post,
      [`${getAssembleiasVotoEndpoint()}voto/`, data],
      'save'
    )
      .then((resp: AxiosResponse<IAssembleiaAssociadoPautaVoto[]>) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      })
      .catch((error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      });
  };
};

export const assembleiasAssociadoActionsLoadPautas = (
  assembleiaId: number,
  callbackSuccess?: (pautas: IAssembleiaAssociadoPauta[]) => void,
  callbackError?: (error: AxiosError<ErrorApi>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (pautas: IAssembleiaAssociadoPauta[]) => void,
        reject: (error: AxiosError<ErrorApi>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getEventoAssociadoEndpoint()}pauta/pautas-evento?idEvento=${assembleiaId}`,
          ],
          'assembleiasAssociadoActionsLoadContas'
        ).then(
          (resp) => {
            const pautas: IAssembleiaAssociadoPauta[] =
              resp.data as IAssembleiaAssociadoPauta[];
            const data: IAssembleiaAssociadoPauta[] = pautas.map(
              (pauta: IAssembleiaAssociadoPauta): IAssembleiaAssociadoPauta => {
                return getPautaAssociadoWithOrderedOptions(pauta);
              }
            );
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS,
              assembleiaId,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorApi>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (pautas) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(pautas);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

let contasLoading: {
  assembleiaId: number;
  cpfCnpj: string;
  loading: boolean;
}[] = [];

const getContasLoadingIndex = (assembleiaId: number): number => {
  return contasLoading
    .map((conta): number => {
      return conta.assembleiaId;
    })
    .indexOf(assembleiaId);
};

const contasIsLoading = (assembleiaId: number, cpfCnpj: string): boolean => {
  const foundIndex = getContasLoadingIndex(assembleiaId);
  const found = foundIndex > -1 ? contasLoading[foundIndex] : null;
  if (found) {
    return (
      found.assembleiaId === assembleiaId &&
      found.cpfCnpj === cpfCnpj &&
      found.loading
    );
  }
  return false;
};

const setContasLoading = (
  assembleiaId: number,
  cpfCnpj: string,
  loading: boolean = true
) => {
  const foundIndex = getContasLoadingIndex(assembleiaId);
  if (foundIndex > -1) {
    contasLoading[foundIndex] = {
      ...contasLoading[foundIndex],
      loading,
    };
  } else {
    contasLoading.push({
      assembleiaId,
      cpfCnpj,
      loading,
    });
  }
};

export const assembleiasAssociadoActionsLoadContas = (
  assembleiaId: number,
  cpfCnpj: string,
  callbackSuccess?: (contas: IAssembleiaContasAssociado) => void,
  callbackError?: (error: AxiosError<ErrorApi>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    if (contasIsLoading(assembleiaId, cpfCnpj)) {
      return;
    }
    setContasLoading(assembleiaId, cpfCnpj, true);
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (contas: IAssembleiaContasAssociado) => void,
        reject: (error: AxiosError<ErrorApi>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssociadoEndpoint()}convocado/${cpfCnpj}/evento/${assembleiaId}`,
          ],
          'assembleiasAssociadoActionsLoadContas'
        ).then(
          (resp) => {
            const contas: IAssembleiaContaAssociado[] = resp.data
              .contas as IAssembleiaContaAssociado[];

            let idsAssociado: number[] = [];
            const data: IAssembleiaContasAssociado = {
              assembleiaId: assembleiaId,
              flagPresencaNaoOnline: resp.data.flagPresencaNaoOnline,
              flagMenorSemEmancipado: resp.data.flagMenorSemEmancipado,
              contas: contas.filter((conta: IAssembleiaContaAssociado) => {
                if (idsAssociado.indexOf(conta.idAssociado) === -1) {
                  idsAssociado.push(conta.idAssociado);
                  return true;
                }
                return false;
              }),
            };

            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO,
              payload: data.flagMenorSemEmancipado,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE,
              payload: data.flagPresencaNaoOnline,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
              payload: false,
            });
            setContasLoading(assembleiaId, cpfCnpj, false);
            resolve(data);
          },
          (error: AxiosError<ErrorApi>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
              payload: false,
            });
            setContasLoading(assembleiaId, cpfCnpj, false);
            reject(error);
          }
        );
      }
    ).then(
      (contas) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsRegistrarPresenca = (
  cpfCnpj: string,
  aceite: number | null,
  convocacoes: number[],
  idEvento: number,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorApi>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    new Promise((resolve, reject) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssociadoEndpoint()}presenca/`,
          {
            aceite,
            convocacoes,
            idEvento,
          },
        ],
        'save'
      ).then(
        () => {
          dispatch({
            type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA,
            payload: {
              cpfCnpj,
              aceite: aceite === 1,
              idsConvocados: convocacoes,
              assembleiaId: idEvento,
            },
          });
          resolve(undefined);
        },
        (error: AxiosError<ErrorApi>) => {
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsLoadAll = (
  callbackSuccess?: (all: IEventosPorAssociado[]) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
      payload: true,
    });
    const { fail, data } = await eventoAPI.listarEventosAssociado();
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL,
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
      payload: false,
    });
  };
};

export function assembleiasAssociadoActionsDeleteCurrentEvent(): IAssembleiaAssociadoDeleteCurrentEvent {
  return {
    type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT,
    payload: undefined,
  };
}

type ThunkLoadEventReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  AssembleiasAssociadoActionTypes
>;

export function assembleiaAssociadoActionsLoadEvent(
  idEvent: number,
  successCallback?: (evento: IAssembleiaAssociadoEvento) => void,
  errorCallback?: (error: ErrorApi) => void
): ThunkLoadEventReturn {
  return async (dispatch) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
      payload: true,
    });
    const { fail, data } = await eventoAPI.carregar(idEvent);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT,
        payload: data,
      });
      successCallback && successCallback(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
      payload: false,
    });
  };
}

export type ThunkDownloadDocumentReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  AssembleiasAssociadoActionTypes
>;

export function assembleiaAssociadoActionsDownloadDocument(
  idEvento: number,
  idDocument: number,
  fileName: string,
  successCallback?: () => void,
  errorCallback?: (error: ErrorApi) => void
): ThunkDownloadDocumentReturn {
  return async (dispatch, getState) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
      payload: [...getState().assembleias.downloadindDocument, idDocument],
    });
    const { fail, data } = await documentosAPI.download(idEvento, idDocument);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (data) {
      trigger(fileName, data);
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS,
        payload: [...getState().assembleias.downloadSuccessfully, idDocument],
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
      payload: getState().assembleias.downloadindDocument.filter(
        (id) => id !== idDocument
      ),
    });
  };
}

export type ThunkLoadDuvidasReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  AssembleiasAssociadoActionTypes
>;

export const assembleiaAssociadoActionsLoadDuvidas = (
  idEvento: number,
  usuario: any,
  successCallback?: () => void,
  errorCallback?: (error: ErrorApi) => void
): ThunkLoadDuvidasReturn => {
  return async (dispatch) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
      payload: true,
    });
    const { fail, data } = await duvidasAPI.listar(idEvento);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS,
        payload: data,
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
      payload: false,
    });
  };
};

export const assembleiasAssociadoActionsLoadByCpfCnpj = (
  cpfCnpj: string,
  captchaToken: string,
  callbackSuccess?: (all: IAssembleiaConsultaByCpfCnpj[]) => void,
  callbackError?: (error: AxiosError<ErrorApi>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
      payload: true,
    });
    // axios.get.apply({}, ['test', {headers: { captchaToken: ''}}])
    toRequest(
      axios.get,
      [
        `${getEventoAssociadoEndpoint()}evento/consulta-associado/${cpfCnpj}`,
        {
          headers: {
            captchaToken,
          },
        },
      ],
      'assembleiasAssociadoActionsLoadByCpfCnpj'
    )
      .then((resp) => {
        const data: IAssembleiaConsultaByCpfCnpj[] =
          resp.data as IAssembleiaConsultaByCpfCnpj[];
        dispatch({
          type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      })
      .catch((error: AxiosError<ErrorApi>) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
          payload: false,
        });
      });
  };
};

export const assembleiasAssociadoActionsLoadRespostaPauta = (
  idPauta: number,
  callbackSuccess?: (all: IAssembleiaAssociadoRespostaPauta) => void,
  callbackError?: (error: AxiosError<ErrorApi>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssociadoActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
      payload: true,
    });
    new Promise(
      (
        resolve: (all: IAssembleiaAssociadoRespostaPauta) => void,
        reject: (error: AxiosError<ErrorApi>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssociadoEndpoint()}resposta-pauta/${idPauta}/por-agencia`,
          ],
          'assembleiasAssociadoActionsLoadRespostaPauta'
        ).then(
          (resp) => {
            const data: IAssembleiaAssociadoRespostaPauta =
              resp.data as IAssembleiaAssociadoRespostaPauta;
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorApi>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (all) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssociadoActionsResultadoParcialAGO = (
  idPauta: number,
  callbackSuccess?: (resultado: ResultadoParcialResponse) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await pautasApi.resultadoParcialAGO(idPauta);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const assembleiasAssociadoActionsCheckVotePermission = (
  idEvento: number,
  callbackSuccess?: Function,
  callbackError?: (error: any) => void
) => {
  return (dispatch: any) => {
    new Promise((resolve: Function, reject: (error: any) => void) => {
      toRequest(
        ApiService.get,
        [
          `${getAssembleiasAssociadoEndpoint()}quorum/${idEvento}`,
          {
            idEvento,
          },
        ],
        'save'
      ).then(
        (resp) => {
          dispatch({
            type: ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION,
            payload: resp,
          });
          resolve();
          if (typeof callbackSuccess === 'function') {
            callbackSuccess(resp.data);
          }
        },
        (error: any) => {
          reject(error);
        }
      );
    }).then(
      () => {
        return;
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
